//
// Copyright (c) 2008-2025 Barry E. Mapen All Rights Reserved
//
import choiceService from './choiceService';

export const createApplication = async (fields, token) => {
    try {
        const url = `/v1.0/application/`;
        const res = await choiceService.post(url, { ...fields, token: token });
        return (res.data);
    } catch (error) {
        console.error(" error trying to createApplication", error);
        return (undefined);
    }
}

